import { render, staticRenderFns } from "./event-detail-notice.vue?vue&type=template&id=78528dd0&scoped=true&"
import script from "./event-detail-notice.vue?vue&type=script&lang=js&"
export * from "./event-detail-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78528dd0",
  null
  
)

export default component.exports